<template>
    <div class="user-menu__buttons">
        <PopupBanners
            :popup-banners-modal-visible="popupBannersModalVisible"
            :jackpot-sportka="jackpotSportka"
            :jackpot-eurojackpot="jackpotEurojackpot"
            @close-popup-banners-modal="closePopupBannersModal"
        />
        <DrawAttendance
            :draw-attendance-popup-visible="drawAttendancePopupVisible"
            :draws="userWalletData.draws"
            @open-popup-banners-modal="openPopupBannersModal"
            @toggle-draw-attendance-popup="toggleDrawAttendancePopup"
        />

        <UserBalance
            :user-balance-popup-visible="userBalancePopupVisible"
            :withdrawable-amount="userWalletData.withdrawableAmount"
            :withdrawal-expiration="userWalletData.withdrawalExpiration"
            @toggle-user-balance-popup="toggleUserBalancePopup"
        />
    </div>

    <BonusBanner v-if="showObtainableBonus" @close-bonus-banner="closeBonusBannerHandler" />
</template>

<script lang="ts" setup>
import { computed, ref } from "vue";
import { useHeader } from "@/composables/use-header";
import { getJackpotsForPopupBanners } from "@/api-connector/sazka-api/methods/draw-info-api";
import BonusBanner from "@/components/header/navigation-buttons-authenticated/bonus-banner.vue";
import PopupBanners from "@/components/header/navigation-buttons-authenticated/popup-banners.vue";
import DrawAttendance from "@/components/header/navigation-buttons-authenticated/draw-attendance.vue";
import UserBalance from "@/components/header/navigation-buttons-authenticated/user-balance.vue";
import { isObtainableBonusOpen, storeObtainableBonusClosed } from "@/account/composables/user-cookies";
import { useUserData } from "@/account/use-user-data";
import { Loader } from "@sazka/design-system/src/loader/loader";
import { settings } from "@/settings";

const { drawAttendancePopupVisible, userBalancePopupVisible, closeMenu } = useHeader();
const { userWalletData } = useUserData();

const popupBannersModalVisible = ref<boolean>(false);
const jackpotSportka = ref<number>(0);
const jackpotEurojackpot = ref<number>(0);

const openPopupBannersModal = async () => {
    Loader.show();

    try {
        const jackpots = await getJackpotsForPopupBanners();
        jackpotSportka.value = jackpots.Sportka.value;
        jackpotEurojackpot.value = jackpots.Eurojackpot.value;
    } catch (err) {
        console.error(err);
    }

    popupBannersModalVisible.value = true;
    drawAttendancePopupVisible.value = false;
    Loader.hide();
};

const closePopupBannersModal = async () => {
    popupBannersModalVisible.value = false;
};

const toggleDrawAttendancePopup = async () => {
    drawAttendancePopupVisible.value = !drawAttendancePopupVisible.value;
    userBalancePopupVisible.value = false;
    closeMenu();
};

const toggleUserBalancePopup = async () => {
    userBalancePopupVisible.value = !userBalancePopupVisible.value;
    drawAttendancePopupVisible.value = false;
    closeMenu();
};

const showObtainableBonus = computed(() => {
    return isObtainableBonusOpen.value && window.location.pathname == settings.url.root;
});

const closeBonusBannerHandler = async () => {
    storeObtainableBonusClosed();
};
</script>
